import React from 'react';
import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import AboutSection from '../components/sections/AboutSection';
import CoursesSection from '../components/sections/CoursesSection';

const Home = () => {
  return (
    <div>
      <Hero />
      <Features />
      <AboutSection />
      <CoursesSection />
    </div>
  );
};

export default Home;
